import axios from 'axios'
import store from '@/store'
import router from '@/router'

const POLLING_MODE = 'polling'
const SNAPSHOT_REFRESH_DELAY_MS = 150
let snapshotRefreshTimer = null

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: process.env.VUE_APP_API_TIMEOUT
})

const normalizeUrl = (url = '') => {
  const apiUrl = process.env.VUE_APP_API_URL || ''
  const normalized = url.replace(apiUrl, '')
  return normalized.startsWith('/') ? normalized : `/${normalized}`
}

const shouldRefreshRentUpdates = (config = {}) => {
  const method = (config.method || '').toLowerCase()
  if (!['post', 'put', 'patch', 'delete'].includes(method)) return false

  const url = normalizeUrl(config.url || '')
  return [
    '/rent',
    '/checkout',
    '/payment',
    '/operation',
    '/product',
    '/period',
    '/toy'
  ].some((resource) => url === resource || url.startsWith(`${resource}/`))
}

const schedulePollingSnapshotRefresh = (config) => {
  if (store.state.multiStoresSse?.mode !== POLLING_MODE) return
  if (!shouldRefreshRentUpdates(config)) return

  if (snapshotRefreshTimer) {
    clearTimeout(snapshotRefreshTimer)
  }

  snapshotRefreshTimer = setTimeout(() => {
    snapshotRefreshTimer = null
    store.dispatch('multiStoresSse/fetchStoresSnapshot', null, { root: true })
  }, SNAPSHOT_REFRESH_DELAY_MS)
}

instance.interceptors.request.use((config) => {
  const { accessToken } = store.state.auth

  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`
  }

  config.headers['Cache-Control'] = 'no-cache'
  config.headers['Pragma'] = 'no-cache'

  return config
})

instance.interceptors.response.use(
  (response) => {
    schedulePollingSnapshotRefresh(response.config)
    return response.data
  },
  async (error) => {
    if (error?.response?.status === 401) {
      if (error?.config?.url !== '/auth/refreshToken') {
        await store.dispatch('auth/refreshToken')
      } else {
        router.push({ name: 'Login' })
      }
    }

    return Promise.reject(error)
  }
)

export default instance
